module.exports = __webpack_public_path__ + "img/london-office-3.ee5e40fa.jpg";